var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "offline-message-container" },
    [
      _c("transition", { attrs: { name: "fade-down" } }, [
        _vm.onlineStatus === _vm.onlineStates.recovered
          ? _c("div", { staticClass: "priority-message message-online" }, [
              _c("p", [_vm._v("😄 It looks like you're online again!")])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.onlineStatus === _vm.onlineStates.offline
          ? _c("div", { staticClass: "priority-message message-offline" }, [
              _c("p", [
                _vm._v(
                  "Oh no! 😔 You appear to be offline, you will not be able to place an order"
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.onlineStatus === _vm.onlineStates.failure
          ? _c("div", { staticClass: "priority-message message-offline" }, [
              _c("p", [_vm._v(_vm._s(_vm.displayMessage))])
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b39bf2c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b39bf2c4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseOffline.vue
// module id = null
// module chunks = 